import * as React from 'react';

import { FallbackType } from '@/context/Page/Page.interface';
import { PageContext } from '@/context/Page/PageContext';

export const usePage = () => {
    const { updateFallback } = React.useContext(PageContext);

    const onLoad = React.useCallback(
        (component: FallbackType | undefined) => {
            if (component === undefined) component = null;
            updateFallback(component);
        },
        [updateFallback],
    );

    return { onLoad };
};
